//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'userbar',
  data() {
    return {
      mobileData: true,
      bluetooth: false,
      confirm_login: false,
      login_message: ''
    }
  },
  methods: {
    onLeft: function () {

    },
    onRight: function () {

    },
    loginout: function () {
      console.log('loginout click');
      this.$store.commit('loginout');
    },
    show_login_dialog: function (login_message = '尚未登录，请先登录或注册') {
      this.login_message = login_message;
      this.confirm_login = true;
    }
  },
  created() {
    window._userbar = this;
    this.$app._userbar = this;
    console.log("userbar $store.state.hasLogin:", this.$store.state.hasLogin);
    this.listener_login = this.$hub.on('event:login', (data) => {
      console.log('event:login', data);
      this.$forceUpdate();
    });
    this.listener_loginout = this.$hub.on('event:loginout', (data) => {
      console.log('event:loginout', data);
      this.$forceUpdate();
    });
  },
  destroyed() {
    this.listener_login.off();
    this.listener_loginout.off();
  }
}
